import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllBanners, getCarouselBanners, listDealBanners } from "../../../api/banner";

export const fetchBanners = createAsyncThunk("fetchBanners", async () => {
  const res = await getAllBanners();
  return res;
});

export const fetchCarouselBanners = createAsyncThunk("fetchCarouselBanners", async () => {
  const { simpleBanners } = await getCarouselBanners();
  return simpleBanners;
});


export const fetchDealBanners = createAsyncThunk("fetchDealBanners", async () => {
  const res = await listDealBanners();
  return res;
});

const initialState = {};

const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.firstList = action.payload.firstList;
        state.secondList = action.payload.secondList;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchDealBanners.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchDealBanners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
      })
      .addCase(fetchDealBanners.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchCarouselBanners.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCarouselBanners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.carouselBanners = action.payload;
      })
      .addCase(fetchCarouselBanners.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});
export const { reset } = bannerSlice.actions;
export { bannerSlice };
